<template>
  <div class="item-actions" v-if="hasPony && authenticated">
    <div class="item-action-holder">
      <ButtonCollectPony
        :pony="pony"
      />
    </div>
    <div class="item-action-holder">
      <ButtonWishlistPony
        :pony="pony"
      />  
      <!-- <p><router-link :to="`/wishlist-item/${pony.id}`">Wishlist Item</router-link></p> -->
    </div>
    <div class="item-action-holder">
      <ButtonFavoritePony
        :pony="pony"
      />
    </div>
  </div>
</template>

<script>
import ButtonCollectPony from '../ButtonCollectPony/ButtonCollectPony';
import ButtonWishlistPony from '../ButtonWishlistPony/ButtonWishlistPony';
import ButtonFavoritePony from '../ButtonFavoritePony/ButtonFavoritePony';

export default {
  name: 'PonyListActions',
  components: {
    ButtonCollectPony,
    ButtonWishlistPony,
    ButtonFavoritePony
  },
  props: {
    pony: {
      type: Object,
      required: true
    },
    authenticated: {
      type: Boolean
    }
  },
  methods: {
    hasPony() {
      return Object.keys(this.pony).length;
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../assets/sass/config';

.item-actions {
  justify-content: flex-start;
  padding-left: 0;
  margin: 0;
}

.item-action {
  padding-right: 20px;

  p {
    padding: 0;
    margin: 0;
  }

  // .fa,
  // .fas,
  // .far {
  //   font-size: 18px;
  //   color: $accent-color;
  //   padding-right: 5px;
  // }
}

.item-actions {
  border-top: 1px solid $accent-color;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 0 0;
}

.elr-card-body .item-actions {
  border-top: 0;
  border-bottom: 0;
}

.item-action-holder {
  padding-right: 0;
  flex: 1;
}
</style>
